module.exports = __webpack_public_path__ + "static/media/infoq-dpop.9c548d62.jpg";